var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99 124",
    style: {
      enableBackground: "new 0 0 99 124"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5,88v11.5H6.1V19.7h61.4v11.4c0.9-0.1,1.9-0.1,2.9-0.1c1.1,0,2.2,0.1,3.3,0.2V7c0-3.1-2.5-5.7-5.6-5.7c0,0,0,0,0,0H5.7 C2.6,1.3,0,3.9,0,7v111.3c0,3.1,2.6,5.7,5.7,5.6c0,0,0,0,0,0H68c3.1,0,5.6-2.5,5.6-5.6c0,0,0,0,0-0.1V88 C71.6,88.2,69.5,88.2,67.5,88z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7,85.5c-0.4,0-0.8,0-1.3-0.2c-1.3-0.6-1.9-1.7-1.9-2.8v-10H48c-1.7,0-3.2-1.5-3.2-3.2V40.1c0-1.7,1.5-3.2,3.2-3.2h47.8 c1.7,0,3.2,1.5,3.2,3.2v29.5c0,1.7-1.5,3.2-3.2,3.2H74.6l-14,12.3C60.1,85.3,59.3,85.5,58.7,85.5z M51,66.4h7.6 c1.7,0,3.2,1.5,3.2,3.2v6.2l9.8-8.5c0.6-0.4,1.3-0.8,2.1-0.8h19.1V43.1H51V66.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,55c0,1.9-1.5,3.2-3.2,3.2c-1.9,0-3.2-1.5-3.2-3.2c0-1.7,1.3-3.2,3-3.2C73.7,51.8,75.2,53.3,75.2,55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1,55c0,1.9-1.5,3.2-3.2,3.2c-1.9,0.2-3.4-1.3-3.4-3.2c0-1.9,1.5-3.2,3.2-3.2C60.6,51.8,62.1,53.3,62.1,55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2,55c0,1.9-1.5,3.2-3.2,3.2c-1.9,0-3.2-1.5-3.2-3.2c0-1.7,1.3-3.2,3.2-3.2C86.7,51.8,88.2,53.3,88.2,55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagement);
export default __webpack_public_path__ + "static/media/engagement.e4999e241a3a4f34250ec591435fdc61.svg";
export { ForwardRef as ReactComponent };